// Copyright (c) 2016 Deere & Company

import {getDefaultState as getLocationDefaultState} from './location';
import t from 'tcomb';

const Dealer = t.struct({
    account: t.String,
    currency: t.String,
    division: t.String,
    email: t.String,
    industryIndicator: t.String,
    leadAccount: t.String,
    location: t.Object,
    name: t.String,
    phone: t.String
}, {
    name: 'Dealer',
    strict: true
});

export const getDefaultState = () => new Dealer({
    account: '',
    currency: '',
    division: '',
    email: '',
    industryIndicator: '',
    leadAccount: '',
    location: getLocationDefaultState(),
    name: '',
    phone: ''
});

export default Dealer;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer.js